import { mutatorAction } from 'satcheljs';
import { getUserMailboxId, MailboxType, getUserMailboxInfo } from 'owa-client-ids';
import { getFolderTable, ARCHIVE_FOLDERS_TREE_TYPE, SHARED_FOLDERS_TREE_TYPE, getAnchorMailboxHeaderForFolderId, getDefaultRequestOptions, } from 'owa-folders';
import getStore from '../store/store';
/**
 * Utility which returns user mailbox info as per folder id
 * @param folderId
 */
export default function fetchUserMailboxInfoFromFolderId(folderId) {
    // Return request options as default mailbox info if folderId is not present
    if (!folderId) {
        return getUserMailboxInfo();
    }
    // Save recomputation by storing the request options in a map per folder
    if (!getStore().has(folderId)) {
        var mailboxInfo = {
            type: MailboxType.UserMailbox,
            returnModernConversationItems: false,
            mailboxId: getUserMailboxIdUsingFolderId(folderId),
            requestOptions: getDefaultRequestOptions(folderId),
        };
        addToStore(folderId, mailboxInfo);
    }
    return getStore().get(folderId);
}
/**
 * Fetches user mailbox id for a given folder id
 * @param folderId
 */
function getUserMailboxIdUsingFolderId(folderId) {
    var folderTable = getFolderTable();
    var folder = folderTable && folderTable.get(folderId);
    if (!folder) {
        return getUserMailboxId();
    }
    if (folder.treeType === ARCHIVE_FOLDERS_TREE_TYPE ||
        folder.treeType === SHARED_FOLDERS_TREE_TYPE) {
        return getAnchorMailboxHeaderForFolderId(folderId);
    }
    else {
        return getUserMailboxId();
    }
}
var addToStore = mutatorAction('addMailboxInfoToStore', function (folderId, mailboxInfo) {
    getStore().set(folderId, mailboxInfo);
});
//# sourceMappingURL=fetchUserMailboxInfoFromFolderId.js.map